import React from 'react';

// breakdown: optional [{ label, value }] -- extra smaller rows under the main
// value/label, e.g. "Needing Attention" / "Scheduled" splits within a stage.
const StatCard = ({ label, value, sub, accent, breakdown }) => (
  <div className={`stat-card stat-card--${accent}`}>
    <div className="stat-card__value">{value}</div>
    <div className="stat-card__label">{label}</div>
    {sub && <div className="stat-card__sub">{sub}</div>}
    {breakdown && breakdown.length > 0 && (
      <div className="stat-card__breakdown">
        {breakdown.map((b) => (
          <div key={b.label} className="stat-card__breakdown-row">
            <span className="stat-card__breakdown-value">{b.value}</span>
            <span className="stat-card__breakdown-label">{b.label}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default StatCard;
